import { Button, Heading, Input, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CreateUserAuth } from '../../api/users';
import FullPageForm from '../../components/FullPageForm';
import { signUpWithEmailAndPasswordHelper } from '../../firebase';
import LoginWithProvider from './LoginWithProvider';
import OrDivider from './OrDivider';

function CreateAccount() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    return (
        <FullPageForm>
            <Heading marginBottom="0" marginTop="4">
                Create an account
            </Heading>
            <Text marginBottom="10" width="90%" color="gray.600">
                To finish your profile and start applying to jobs, create a free PathMatch account
            </Text>
            <LoginWithProvider />
            <OrDivider />
            <Input
                type="text"
                marginBottom="2"
                value={email}
                size="lg"
                px="12px"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
            />
            <Input
                type="password"
                marginBottom="2"
                value={password}
                size="lg"
                px="12px"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
            />
            <Button
                width="100%"
                colorScheme="brand"
                marginBottom="4"
                size="lg"
                fontWeight="600"
                borderRadius="full"
                onClick={async () =>{
                    const success = await signUpWithEmailAndPasswordHelper(
                        email,
                        password,
                        searchParams.get('profileId'),
                        searchParams.get('cid'),
                        setErrorMessage
                    ).then(async (userCredential) => {
                        try{
                            const token = await userCredential.user.getIdToken();
                            
                            sessionStorage.setItem('accessToken', token);
                            sessionStorage.setItem('email', userCredential.user.email ?? '');
                            const user = await CreateUserAuth(
                                token,
                                userCredential.user.email ?? '',
                                userCredential.user.uid ?? ''
                            );
            
                            return user.data.createUserAuth.success;
                        }
                        catch(error){
                            console.log(error);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setErrorMessage(error.message);
                    });
                    if (success) navigate('/createProfile');
                }
                }
            >
                Sign Up
            </Button>
            <Text color="red">{errorMessage}</Text>
        </FullPageForm>
    );
}
export default CreateAccount;
